<template>
  <div id="payment-history" class="table-responsive">
    <table class="table table-sm table-striped table-hover table-bordered">
      <thead>
        <tr>
          <th scope="col">Payable Year</th>
          <th scope="col">Entry Date</th>
          <th scope="col">Payable Period</th>
          <th scope="col" class="text-end">Amount Paid</th>
          <th scope="col" v-if="$route.params.slug !== 'dekalbcounty'">
            Notes
          </th>
          <th scope="col">Property Project</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!items.length">
          <td colspan="6" class="text-center text-muted p-3">
            No data
          </td>
        </tr>
        <tr v-for="(item, index) in items" v-bind:key="index">
          <th scope="row">{{ item.PAYABLEYEAR }}</th>
          <td>{{ item.ENTRYDATETIME | toDate }}</td>
          <td>{{ item.PAYABLEPERIOD }}</td>
          <td class="text-end">{{ item.ReceiptDetailsAmount | currency }}</td>
          <td v-if="$route.params.slug !== 'dekalbcounty'">{{ item.Notes }}</td>
          <td>{{ item.IsPropertyProject }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  methods: {
    formatPayablePeriod(period) {
      if (period === "S") return "Spring";
      if (period === "F") return "Fall";
      return "";
    }
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>
